export default __webpack_public_path__ + "static/media/Erika.8dda3e73.png";